import { Ref } from "react";

//#region Submit Function
export const MAIN_SUBMIT_BUTTON_NAME = "main";

interface SubmitEventInit extends EventInit {
    submitter?: string
}

export class SubmitEvent extends Event {
    submitter: string;

    constructor(type: string, eventInitDict?: SubmitEventInit) {
        super(type, eventInitDict);
        this.submitter = eventInitDict?.submitter || MAIN_SUBMIT_BUTTON_NAME;
    }
}

export type SubmitFunction = (e: SubmitEvent) => void | Promise<void>
//#endregion

//#region Fields
export type FieldInput = {
    id: string,
    name: string,
    type: "fieldInput",
    element: HTMLElement,
    focus: (select?: boolean) => boolean,
}

export type FieldSetField = {
    id: string,
    name: string,
    type: "fieldSetField",
    element: HTMLElement,
    focusField: (id: string, select?: boolean) => boolean,
    focusFirst: (select?: boolean) => boolean,
    focusLast: (select?: boolean) => boolean,
}

export type SubmitButton = {
    id: string,
    name: string,
    type: "submitButton",
    element: HTMLElement,
    focus: () => boolean,
}
//#endregion

export interface FieldInputApi {
    id: string,
    name: string,
    ref: Ref<HTMLElement>,
    fieldSet: FieldSetApi
}

export interface SubmitButtonApi {
    id: string,
    name: string,
    ref: Ref<HTMLElement>,
    fieldSet: FieldSetApi
    isSubmitting: boolean,
    submit: () => void,
}

export interface FieldSetApi {
    id: string,
    name: string,
    ref: Ref<any>,
    parentFieldSet?: FieldSetApi,

    register: (field: FieldInput | SubmitButton | FieldSetField) => void,
    unregister: (id: string) => void,
    
    focusFieldById: (fieldId: string, select?: boolean) => boolean,
    focusFieldByName: (name: string, select?: boolean) => boolean,
    focusNextField: (currentFieldId: string, select?: boolean) => boolean,
    focusPreviousField: (currentFieldId: string, select?: boolean) => boolean,
    focusFirstField: (select?: boolean) => boolean,
    focusLastField: (select?: boolean) => boolean,

    focusSubmitButtonById: (id: string) => boolean,
    focusSubmitButtonByName: (name: string) => boolean,

    clickSubmitButton: (submitButtonId?: string) => void,
    submit: (submitButtonId?: string) => void | Promise<void>,

    disabled: boolean,
    submitterId: string | undefined,
}